/**
 * Per-template dismissal key for CaptureGuidanceCard.
 *
 * Replaces the single global `CAPTURE_GUIDANCE_LS_KEY`: dismissing the capture
 * guidance for one movement must not hide it for a different movement filmed
 * from a different angle, which is exactly what one shared key did.
 *
 * Kept in its own module rather than exported from CaptureGuidanceCard.tsx so
 * that file exports only its component (react-refresh/only-export-components).
 */
export function captureGuidanceDismissKey(templateId: string | null | undefined): string {
  return `capture-guidance-dismissed:${templateId ?? 'unknown'}`;
}
